import React from 'react'
import {Box, Container, Flex, Text, BaseButton} from '../../vanilla'
import {ChevronLeftIcon, BrandLogo, LockIcon, ArrowLeftIcon} from '../icons'
import {Link} from '../link'
import {useHistory, useRouteMatch} from 'react-router-dom'
import {CHECKOUT_SUMMARY_PATH} from '../../constants'
import BonusCardApp from '../../utils/app'
import {useLocation} from 'react-router-dom'

interface SimpleHeaderProps {
  customerIsRegistered?: boolean
}

export const SimpleHeader = (props: SimpleHeaderProps) => {
  const appPagesToExcludeBackBtn: string[] = ['/login']
  const {isExact: hideBackButtonForPage} = useRouteMatch(appPagesToExcludeBackBtn) || {
    isExact: false
  }
  const app = new BonusCardApp()

  const isBackButtonAvailable = () => {
    // If in mobile app and there is no history to go back, or we are on app-specific exclusion page, button is unavailable
    if (
      typeof window === 'undefined' ||
      (app.isApp() && hideBackButtonForPage) ||
      (app.isApp() && window.history.length <= 1)
    ) {
      return false
    }
    return true
  }

  const history = useHistory()
  const location = useLocation()

  const {isExact: useSecureIcon} = useRouteMatch([
    CHECKOUT_SUMMARY_PATH,
    '/account/bonus-card/topup'
  ]) || {
    isExact: false
  }

  const redirects = {
    '/account/register': {
      redirectTo: '/login',
      backText: 'Back to login'
    },
    '/login': {
      redirectTo: '/',
      backText: 'Back to home'
    },
    '/meal-deals': {
      redirectTo: '/meal-deals',
      backText: 'Back to Meal Deals'
    },
    '/select-delivery': {
      redirectTo: '/',
      backText: 'Back to home'
    }
  }

  const referringPath = (history.location.state as {directedFrom?: string} | null)?.directedFrom
  const pathOnly = referringPath ? referringPath.split('?')[0] : null
  const currentRedirect =
    redirects[(pathOnly || location.pathname) as keyof typeof redirects] || null
  const goBack = () => {
    if (currentRedirect) {
      history.push(currentRedirect.redirectTo)
    } else {
      history.goBack()
    }
  }
  const backButtonAriaLabel = currentRedirect ? currentRedirect.backText : 'Back'

  return (
    <>
      <Box as="header" width="full" bg="white">
        <Container paddingX={['16px', '32px', '16px']}>
          <Flex
            align="center"
            justify="space-between"
            height={{mobile: '44px', desktop: '64px'}}
            marginY={['0px', '8px', '0px']}
          >
            <Flex align="center" width="full" justify={['flex-start', 'space-between']}>
              {isBackButtonAvailable() && (
                <BaseButton
                  variant="unstyled"
                  paddingLeft="0px"
                  onClick={() => {
                    goBack()
                  }}
                  aria-label={backButtonAriaLabel}
                >
                  <ArrowLeftIcon display={['block', 'none']} color="gray800" boxSize="20px" aria-hidden="true" />
                  <ChevronLeftIcon display={['none', 'block']} color="gray800" boxSize="20px" aria-hidden="true" />
                  <Text variant="text3" color="gray800" display={['none', 'block']}>
                    Back
                  </Text>
                </BaseButton>
              )}

              <Box
                as={Link}
                display="block"
                height={['16px', '24px']}
                aria-label="Iceland Foods UK"
                justifySelf="center"
                marginX="auto"
                {...(app.isApp() && location.pathname == '/login' ? {} : {to: '/'})}
              >
                <BrandLogo width="auto" height="full" />
              </Box>
              <Box gap={['8px', '10px']} display="flex">
                <Text as="a" href="/customer-support/contact-us">
                  Help
                </Text>
                {useSecureIcon && (
                  <LockIcon marginLeft={['auto', '0px']} color="accent3" boxSize="24px" />
                )}
              </Box>
            </Flex>
          </Flex>
        </Container>
      </Box>
    </>
  )
}
